/* @flow */

import WidgetGenericKeys from 'CoreConstants/FieldKeysGeneric';
import DSWFieldKeys from 'CoreConstants/FieldKeysDSW';

export default {
  ...WidgetGenericKeys,
  ...DSWFieldKeys
};
